// Extracted from AssignCleanerModal.jsx so every call site can share one
// consistent way of turning an axios error into a user-facing message.
export const getApiErrorMessage = (err, fallback) => {
  if (!err) return fallback;
  const response = err?.response;
  const data = response?.data;

  if (typeof data === "string" && data.trim()) return data.trim();

  if (data && typeof data === "object") {
    // Common DRF / Django keys, in priority order.
    const direct = data.error || data.message || data.detail || data.non_field_errors;
    if (typeof direct === "string" && direct.trim()) {
      // The backend deliberately returns this exact generic body for both
      // "doesn't exist" and "exists but isn't yours" (see
      // SECURITY_VULNERABILITIES.md Section 4) — showing the raw text is
      // confusing on its own, so swap in a clearer, still-generic message.
      if (response?.status === 404 && direct.trim() === "Not found.") {
        return "You don't have access to this, or it no longer exists.";
      }
      return direct.trim();
    }
    if (Array.isArray(direct) && direct.length > 0) {
      return String(direct[0]);
    }
    // DRF field-validation shape: { field_name: ["msg", ...], ... }
    for (const key of Object.keys(data)) {
      const v = data[key];
      if (typeof v === "string" && v.trim()) return v.trim();
      if (Array.isArray(v) && v.length > 0 && typeof v[0] === "string") {
        return v[0];
      }
    }
  }

  if (err?.message && typeof err.message === "string") return err.message;
  return fallback;
};
